import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** Shown while the browser is offline (the PWA shell still opens without a connection). */
export function OfflineBanner() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-[calc(var(--app-bottom)+12px)] z-[60] mx-auto flex w-fit max-w-[calc(100%-24px)] items-center gap-2 rounded-full border border-warning/40 bg-elevated/95 px-4 py-2 text-sm text-warning shadow-glow-1 backdrop-blur md:bottom-6"
    >
      <WifiOff className="size-4" aria-hidden /> You're offline. We'll reconnect when your network is back.
    </div>
  );
}
